import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

import { isDynamicContextBindingConfig } from '../functions/is-dynamic-context-binding-config';
import { IDynamicContextBindingConfig } from '../types/dynamic-context-binding-config.interface';
import { IDynamicContextBindings } from '../types/dynamic-context.interface';

/**
 * Returns a value from the dynamic context based on the provided configuration.
 *
 * If the config does not conform to the IDynamicContextBindingConfig, intentionally or otherwise, the configuration argument
 * will be returned.
 */
@Pipe({ name: 'dynamicContextResolver' })
export class DynamicContextResolverPipe implements PipeTransform {
  transform(config: IDynamicContextBindingConfig | unknown, contextBindings: IDynamicContextBindings) {
    if (!isDynamicContextBindingConfig(config)) {
      return config;
    }

    return get(
      get(contextBindings, (config as IDynamicContextBindingConfig).type),
      (config as IDynamicContextBindingConfig).path
    );
  }
}
